module.exports = __webpack_public_path__ + "static/media/review-13.4d0cbb2d.jpg";